import { Text, Spinner } from "@merge-api/merge-javascript-shared";

interface Props {
  title?: string | JSX.Element;
  isSpinner?: boolean;
}

function EmptyStateWrapper(props: Props) {
  return (
    <div className="flex items-center justify-center m-20">
      {props.title && (
        <Text variant="h4" className="text-gray-40">
          {props.title}
        </Text>
      )}
      {props.isSpinner && <Spinner />}
    </div>
  );
}

export default EmptyStateWrapper;
